import React, {Component} from 'react';
import styled from 'styled-components';

const base64icon = (type) => {

    let color;

    switch (type) {
        case 'beach':
            color = '#F0BE5D';
            break;
        case 'beach_club':
            color = '#3DC7B2';
            break;
        case 'club':
            color = '#AD5DF0';
            break;
        case 'house':
            color = '#e02d5f';
            break;
        case 'place':
            color = '#336AB4';
            break;
        case 'restaurant':
            color = '#5BBDF0';
            break;
        case 'store':
            color = '#fe9900';
            break;
        case 'market':
            color = '#a4de02';
            break;
        default:
            color = '#ddd';
    }

    const encoded = window.btoa('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-100 -100 200 200"><defs><g id="a" transform="rotate(45)"><path d="M0 47A47 47 0 0 0 47 0L62 0A62 62 0 0 1 0 62Z" fill-opacity="0.6"/><path d="M0 67A67 67 0 0 0 67 0L81 0A81 81 0 0 1 0 81Z" fill-opacity="0.4"/><path d="M0 86A86 86 0 0 0 86 0L100 0A100 100 0 0 1 0 100Z" fill-opacity="0.2"/></g></defs><g fill="' + color + '"><circle r="48"/><use xlink:href="#a"/><g transform="rotate(120)"><use xlink:href="#a"/></g><g transform="rotate(240)"><use xlink:href="#a"/></g></g></svg>');

    return 'data:image/svg+xml;base64,' + encoded;
};

const Wrapper = styled.div` 
    color: #fff;
    width: 52px;
    height: 52px;
    background: url(${props => (base64icon(props.type))});
    background-repeat: no-repeat;
    padding-top: 18px;
    font-size: 13px;
    transform: translate(-50%, -50%);
    text-align: center;

`;

class ClusterMarker extends Component {
    render() {
        return (
            <Wrapper type={this.props.type}>
                {this.props.numPoints}
            </Wrapper>
        );
    };
}

export default ClusterMarker;
